"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _renderProp = require("../utils/propTypes/renderProp");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: auto;\n  padding-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var NavItemLabel = _styledComponents.default.span.withConfig({
  displayName: "UINavItemLabel__NavItemLabel",
  componentId: "sc-1l1ye5s-0"
})(_templateObject());

var Count = _styledComponents.default.span.withConfig({
  displayName: "UINavItemLabel__Count",
  componentId: "sc-1l1ye5s-1"
})(_templateObject2(), _sizes.NAV_ITEM_INNER_SPACING_X);

var _default = (0, _createReactClass.default)({
  displayName: 'UINavItemLabel',
  propTypes: {
    children: _propTypes.default.node,
    count: _propTypes.default.node
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        count = _this$props.count,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "count"]);
    return _react.default.createElement(NavItemLabel, (0, _extends2.default)({}, rest, {
      className: className
    }), _react.default.createElement(_react.Fragment, null, children), (0, _renderProp.isRenderable)(count) && _react.default.createElement(Count, null, count));
  }
});

exports.default = _default;
module.exports = exports.default;